import { render, staticRenderFns } from "./privateNumber.vue?vue&type=template&id=00fadc06&scoped=true&"
import script from "./privateNumber.vue?vue&type=script&lang=js&"
export * from "./privateNumber.vue?vue&type=script&lang=js&"
import style0 from "./privateNumber.vue?vue&type=style&index=0&id=00fadc06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fadc06",
  null
  
)

export default component.exports